import { USER_ACTIONS } from "constants";

export function fetchUser() {
    return {
        type: USER_ACTIONS.FETCH_USER
    };
}

export function fetchedUser(user) {
    return {
        type: USER_ACTIONS.FETCHED_USER,
        payload: {
            user
        }
    };
}

export function failedFetchUser(error) {
    return {
        type: USER_ACTIONS.FAILED_FETCH_USER,
        error
    };
}

export function fetchUserPermissions() {
    return {
        type: USER_ACTIONS.FETCH_USER_PERMISSIONS
    };
}

export function fetchedUserPermissions(permissions) {
    return {
        type: USER_ACTIONS.FETCHED_USER_PERMISSIONS,
        payload: {
            permissions
        }
    };
}

export function failedFetchUserPermissions(error) {
    return {
        type: USER_ACTIONS.FAILED_FETCH_USER_PERMISSIONS,
        error
    };
}
